import { Toast,Dialog } from 'vant';
import {WxShare,Wechatauth,wxurl,PersoanalUserInfo,ModulesDetails} from '../../config/interface.js';
import wx from 'weixin-js-sdk'
import { baseURL ,webURL} from '../../config/fetch.js';
import store from '../../store'
const common={
	//消息提示
	toast(message,duration,icon,onClose){
		Toast({
		  message:message,
		  icon:icon,
		  duration:duration,
		  onClose:onClose
		});
	},
	//消息确认
	confirm(title,message,confirm,cancel){
		Dialog.confirm({
		  title:title,
		  message: message
		}).then(() => {
			confirm();
		}).catch(() => {
			if(cancel){
				cancel();
			}
		});
	},
	//分割字符串
	//str 字符串 separator   从该地方进行分割  index  选取第几个数组
	splitString(str,separator,index){
		if(index!='undefined'){
			return str.split(separator)[index];
		}else{
			return str.split(separator);
		}
	},
	//判断一个数是否在数组
	inArray(value,array){
		for(var i=0;i<array.length;i++){
			if(array[i]==value){
				
				return true;
			}
		}
		return false
	},
	//图片发生错误
	imgError(type, event) {
		console.log(event)
		// event.target.src = require('@/assets/images/defaultHead.png');
		if (type == 1) {
			event.target.src = require('@/assets/images/defaultHead.png');
		} else if (type == 2) {
			event.target.src = require('@/assets/images/defaultMeetingCover.png');
		}
		event.srcElement.onerror = null; //控制不要一直跳动
	},
	//得到本地存储
	getLocalStorage(name){
		let str=localStorage.getItem(name);
		return str;
	},
	//本地存储(存储数组)   name:本地存储的名称   word:要存储的内容 
	setLocalStorage(name,word){
		let array=[];
		array.push(word);
		let storage=this.getLocalStorage(name);
		if(storage){
			let data=JSON.parse(storage);
				for(let i=0;i<data.length;i++){
					if(JSON.stringify(array).indexOf(JSON.stringify(data[i]))==-1){
								array.push(data[i])
							}
					}
		}
		localStorage.setItem(name,JSON.stringify(array));

	},
	//清空本地存储
	clearLocalStorage(name){
		localStorage.removeItem(name);
	},
	//url后面是否带有某参数
	getUrlKey: function (name) {
		return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
	},
	/**
	 * 更改页面的定位方式(含有input框并且有元素绝对定位在页面下方)
	 */
	changePosition(el){
		let screenHeight = document.documentElement.clientHeight;
			window.onresize=()=>{
				if(screenHeight>document.documentElement.clientHeight){
					el.style.position='static';
					el.style.margin='3.5rem 0 0'
				}else{
					el.style.position='absolute';
				}
			}
	},
	//獲取用戶信息
	getUserInfo(){
		const url=PersoanalUserInfo;
		let params={};
		const method='POST';
		fetch(url,params,method)
		.then((res)=>{
			if(res.code==0){
				let data=res.data;
				localStorage.setItem('userInfo',JSON.stringify(data));
				store.dispatch('storageUserInfo',data);	
				let obj={
					name:data.name
				}					
				
			}
		})
	},
	configJSDK(data,title,desc,imgUrl){
		console.log(desc,imgUrl)
		wx.config({
			debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
			appId: data.appId, // 必填，公众号的唯一标识
			timestamp:data.timestamp , // 必填，生成签名的时间戳
			nonceStr:data.nonceStr, // 必填，生成签名的随机串
			signature:data.signature,// 必填，签名，见附录1
			jsApiList:data.jsApiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
		});
		wx.ready(function(){
			wx.updateAppMessageShareData({
				title: title, // 分享标题
				desc: desc, // 分享描述
				link: window.location.href, // 分享链接
				imgUrl:'http:'+imgUrl, // 分享图标
				type: 'link', // 分享类型,music、video或link，不填默认为link
				dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
				success: function () { 
					// 用户确认分享后执行的回调函数
				
			
				},
				cancel: function () { 
					// 用户取消分享后执行的回调函数
				}
			});

			wx.error(function(res){
				// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
				alert("errorMSG2:"+JSON.stringify(res),JSON.stringify(data));

			});


		// config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
		});

	},
	fullUrlProtocol:(path,protocol = 'http:')=>{
        if(path.substr(0,2)=='//')
        {
            return protocol+path;
        }
        return path;
    },
	wxPreviewImage(src,previewArr){
		wx.previewImage({
			current: src,
			urls: previewArr
		  });
	},
	//微信分享
	wxShare(title,desc,imgUrl){
		// if(!localStorage.getItem('jsdkdata')){
			const url=WxShare;
			const method='POST';
			let params={
						jssdk:['onMenuShareAppMessage','onMenuShareTimeline'],
						url:window.location.href
			};
			fetch(url,params,method)
			.then((res)=>{
				if(res.code==0){
					let data=res.data;
					
					wx.config({
						debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
						appId: data.appId, // 必填，公众号的唯一标识
						timestamp:data.timestamp , // 必填，生成签名的时间戳
						nonceStr:data.nonceStr, // 必填，生成签名的随机串
						signature:data.signature,// 必填，签名，见附录1
						jsApiList:data.jsApiList // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
					});
					wx.ready(function(){
						//分享给朋友
						wx.onMenuShareAppMessage({
							title: title, // 分享标题
							desc: desc, // 分享描述
							link: window.location.href, // 分享链接
							imgUrl:'http:'+imgUrl, // 分享图标
							type: 'link', // 分享类型,music、video或link，不填默认为link
							dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
							success: function () { 
								// 用户确认分享后执行的回调函数
							
						
							},
							cancel: function () { 
								// 用户取消分享后执行的回调函数
							}
						});
						//分享到朋友圈
						wx.onMenuShareTimeline({
							title:title, 
							link: window.location.href,
							imgUrl:'http:'+imgUrl,
							// type: 'link',
							success: function () {
								// 用户确认分享后执行的回调函数
							},
							cancel: function () {
								// 用户取消分享后执行的回调函数
							}
						});
			
						wx.error(function(res){
							// config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
							// alert("errorMSG2:"+JSON.stringify(res),JSON.stringify(data));
			
						});
			
			
					// config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
					});
				}
			})
		
									
	},
	//微信授权
	wxAuth(){
			window.localStorage.setItem('callback_url',window.location.href);
			let callback_url=window.location.protocol+"//"+window.location.host+'/wechatauth';
			let url=baseURL+Wechatauth+'?callback_url='+encodeURIComponent(callback_url);
			window.location.href=url;		
			console.log('wxAuth',url);

	},
	//判断是不是微信浏览器
	is_weixin(){  
		var ua = navigator.userAgent.toLowerCase();  
		if(ua.match(/MicroMessenger/i)=="micromessenger") {  
			return true;  
		} else {  
			return false;  
		}  
	},
	//获取模块详情  1:专业模块  2:会议模块  3.前言资讯模块   4.病例模块   5.器械模块   6.首页模块  7.文章模块
	moduleDetails(id){
		const url=ModulesDetails;
		const method='POST';
		let params={
			module_id:id   //4病例模块
		}
		fetch(url,params,method)
		.then((res)=>{
			if(res.code==0){
				let data=res.data;
				this.wxShare(data.share_title,data.share_sub_title,data.share_img);
			}
		})
	}

}
export default common;


// WEBPACK FOOTER //
// ./src/assets/js/common.js